import { render, staticRenderFns } from "./TimePersonScreen.vue?vue&type=template&id=9b970876&scoped=true&"
import script from "./TimePersonScreen.vue?vue&type=script&lang=js&"
export * from "./TimePersonScreen.vue?vue&type=script&lang=js&"
import style0 from "./TimePersonScreen.vue?vue&type=style&index=0&id=9b970876&prod&lang=scss&scoped=true&"
import style1 from "./TimePersonScreen.vue?vue&type=style&index=1&id=9b970876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b970876",
  null
  
)

export default component.exports